import loadable from '@loadable/component';

import { Modules } from 'types';

export const loadFreebetModule: () => Promise<
    Modules['freebet']
> = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "freebet-module" */ './index');

export const AsyncBetslipFreebet = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.BetslipFreebet,
});

export const AsyncFreebetPanel = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) => filters.components.FreebetPanel,
});

export const AsyncFreebetSelect = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.FreebetSelect,
});
export const AsyncFreeBetMobileTitle = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.FreeBetMobileTitle,
});
export const AsyncFreeBetCategorizer = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.FreeBetCategorizer,
});

export const AsyncRequestFreebet = loadable(loadFreebetModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.RequestFreebet,
});
